import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format as fnsFormat } from "date-fns";
import { es } from "date-fns/locale";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Safely parse a date value. Returns a valid Date or null.
 */
export function safeDate(value: unknown): Date | null {
  if (value == null) return null;
  const d = new Date(value as string | number);
  return isNaN(d.getTime()) ? null : d;
}

/**
 * Safely format a date with date-fns. Returns the fallback string if the date is invalid.
 */
export function safeFmt(value: unknown, pattern: string, fallback = "—"): string {
  const d = safeDate(value);
  if (!d) return fallback;
  return fnsFormat(d, pattern, { locale: es });
}
